import { useFeature } from '../../services/features/reactBindings/hooks';
import { useConfigSlice } from '../slices/config/selectors';

export const useAutoplayHiddenFlag = (): boolean => {
  const configHideAutoplay = useConfigSlice.casinoConfig()?.hideAutoplay ?? false;
  const removeAutoplay = useConfigSlice.casinoConfig()?.removeAutoplay ?? false;
  const complianceHideAutoplay = useConfigSlice.compliance()?.hideAutoplay ?? false;
  const extendedAutoplay = useConfigSlice.compliance()?.extendedAutoplay ?? false;
  const showAutoPlayForUk = useConfigSlice.casinoConfig()?.removeAutoplay === false; // For uk by default hide the autoplay if remove_auto ===false then we have to show it.
  const disableAutoplay = useFeature('disableAutoplay');
  if (disableAutoplay) return true;
  return (extendedAutoplay && (configHideAutoplay || !showAutoPlayForUk)) || complianceHideAutoplay || removeAutoplay;
};
